import { render, staticRenderFns } from "./headerPreviewCasting.vue?vue&type=template&id=3bd63dc2&scoped=true&"
import script from "./headerPreviewCasting.vue?vue&type=script&lang=js&"
export * from "./headerPreviewCasting.vue?vue&type=script&lang=js&"
import style0 from "./headerPreviewCasting.vue?vue&type=style&index=0&id=3bd63dc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd63dc2",
  null
  
)

export default component.exports